module.exports = __webpack_public_path__ + "img/feature-icon-6.af12fd03.svg";